export const BRAND = {
  name: "ALBAVOX",
  tagline: "Your travel companion.",
  domain: "albavox.com",
  email: "info@albavox.com",
  copyrightYear: 2026,
} as const;

export const APP_LINKS = {
  appStore: "https://apps.apple.com/us/app/albavox/id6749460591",
  googlePlay: "https://play.google.com/store/apps/details?id=com.sh.shabani.ALBAVOXProject&hl=en",
} as const;

export const SOCIAL_LINKS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/albavox_/",
    icon: "Instagram",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61592069065073",
    icon: "Facebook",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/albaavox/",
    icon: "Linkedin",
  },
] as const;
